<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-4">
            <p-dropdown [options]="feeTypes" formControlName="feeType" optionLabel="name"
            optionValue="value" appendTo="body" placeholder="Fee Type" ></p-dropdown>
            <label for="Fee Type">Fee Type</label>
            @for (validation of validationMessages.feeType; track validation) {
              <span>
                @if (form1.get('feeType').hasError(validation.type) && (form1.get('feeType').dirty || form1.get('feeType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="quantity" id="quantity" [required]="true" type="number" pInputText>
            <label for="quantity">Quantity</label>
            @for (validation of validationMessages.quantity; track validation) {
              <span>
                @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputNumber  formControlName="expenseAmnt"  inputId="currency-us" [minFractionDigits]="0" mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="expenseAmnt">Amount</label>
            @for (validation of validationMessages.expenseAmnt; track validation) {
              <span>
                @if (form1.get('expenseAmnt').hasError(validation.type) && (form1.get('expenseAmnt').dirty || form1.get('expenseAmnt').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="expensePct" id="expensePct"
          mask="9.9?9"></p-inputMask>
          <label for="expensePct">Expense Pct</label> -->
          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Percentage : <b>{{expensePct.value*100 | number : '1.0-2'}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('expensePct')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="0" max="1" step=".01"
                pTooltip="Range: 0 to 100 as decimal. Values in percentage"
                tooltipPosition="bottom">
                <input matSliderThumb #expensePct formControlName="expensePct">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('expensePct')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
          @for (validation of validationMessages.expensePct; track validation) {
            <span>
              @if (form1.get('expensePct').hasError(validation.type) && (form1.get('expensePct').dirty || form1.get('expensePct').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="expenseFreqs" formControlName="expenseFreq" optionLabel="name"
          optionValue="value" placeholder="Frequency" ></p-dropdown>
          <label for="Expense Freq">Frequency</label>
          @for (validation of validationMessages.expenseFreq; track validation) {
            <span>
              @if (form1.get('expenseFreq').hasError(validation.type) && (form1.get('expenseFreq').dirty || form1.get('expenseFreq').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
          <label for="description">Ops Notes</label>
          @for (validation of validationMessages.description; track validation) {
            <span>
              @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!--Proforma Parent ID Field here-->

      <!-- <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="proformaList" formControlName="proformaId" optionLabel="userId"
          optionValue="proformaId" [filter]="true" filterBy="userId" [showClear]="false"
          placeholder="Select Property Of Proforma">
        </p-dropdown>
        <label for="Select Property Of Proforma">Select Property Of Proforma</label>
        <span *ngFor="let validation of validationMessages.proformaId">
          <small class="p-invalid"
            *ngIf="form1.get('proformaId').hasError(validation.type) && (form1.get('proformaId').dirty || form1.get('proformaId').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->

  </div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (proformaExpenseId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete Fees and Credits</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!proformaExpenseId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add Fees and Credits</button>
          }

          @if (proformaExpenseId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Fees and Credits</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>